import {
  useVenueUserReadQuery,
  useVenueUserUpdateMutation,
} from "@ticketingplatform/api/dist/venueUser";
import { Form, message } from "antd";
import useApolloErrorFields from "hooks/useApolloErrorFields";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { useMemo } from "react";
import { ROUTE_PATHS } from "const/paths";
import { useNumberParams } from "hooks/useNumberParams";
import usePrompt from "hooks/usePrompt";

import { UserFormProps } from "../../Users/UserForm/types";

export const useVenueUserEditForm = (): UserFormProps<true> => {
  const intl = useIntl();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { id } = useNumberParams(true);
  const { data, loading } = useVenueUserReadQuery({
    variables: { id, venueInclude: false, userInclude: true },
  });
  const [venueUserUpdateMutation, { loading: submitting, error }] =
    useVenueUserUpdateMutation();
  const fields = useApolloErrorFields(error);

  usePrompt(submitting);

  return useMemo(
    () => ({
      form,
      fields,
      loading: loading || submitting,
      phoneIsReadOnly: true,
      isVenueUser: true,
      initialValues: {
        input: {
          firstName: data?.venueUser?.firstName,
          lastName: data?.venueUser?.lastName,
          role: data?.venueUser?.role,
          phoneNumber: data?.venueUser?.user?.phoneNumber,
        },
      },
      async onFinish({ input: { firstName, lastName, role } }) {
        try {
          await venueUserUpdateMutation({
            variables: {
              id,
              input: {
                firstName,
                lastName,
                role,
              },
            },
          });

          message.success(
            intl.formatMessage({
              defaultMessage: "User has been added!",
            })
          );

          navigate(ROUTE_PATHS.SettingsVenueUserList, {
            state: {
              skipBlock: true,
            },
          });
        } catch {
          message.error(
            intl.formatMessage({
              defaultMessage: "Error. Cannot add User.",
            })
          );
        }
      },
    }),
    [
      data?.venueUser?.firstName,
      data?.venueUser?.lastName,
      data?.venueUser?.role,
      data?.venueUser?.user?.phoneNumber,
      fields,
      form,
      id,
      intl,
      loading,
      navigate,
      submitting,
      venueUserUpdateMutation,
    ]
  );
};
